<div id="clients-page" #pageRef>
    <div id="filters" class="display-flex" #filtersRef>
        <mat-form-field [style.width.%]="100" style="margin: 0 15px;">
            <input matInput id="search-criteria" placeholder="Wpisz numer lub nazwę klienta..."
                [(ngModel)]="searchCriteria" (keyup.enter)="searchClients()" />
        </mat-form-field>
        <button matButton="filled" id="search-button" (click)="searchClients()">Wyszukaj</button>
    </div>
    <div id="clients-table-container" class="display-flex" [style.height]="tableContainerHeight">
        <mat-table [dataSource]="clients" id="clients-table" class="mat-elevation-z8 selectable-table">
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
                <mat-cell *matCellDef="let client">{{client.name}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="appInstanceName">
                <mat-header-cell *matHeaderCellDef>Instancja</mat-header-cell>
                <mat-cell *matCellDef="let client">{{client.appInstanceName}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="createDate">
                <mat-header-cell *matHeaderCellDef>Date rejestracji</mat-header-cell>
                <mat-cell *matCellDef="let client">{{client.createDate | date:'dd-MM-yyyy HH:mm'}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="active">
                <mat-header-cell *matHeaderCellDef>Aktywny</mat-header-cell>
                <mat-cell *matCellDef="let client"><span [outerHTML]="client.active | boolToImg"></span></mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="['name', 'appInstanceName', 'createDate', 'active']"
                class="table-header"></mat-header-row>
            <mat-row *matRowDef="let client; columns: ['name', 'appInstanceName', 'createDate', 'active']"
                (click)="selectClient(client)"></mat-row>
        </mat-table>
    </div>
</div>